import { useContext, useEffect, useState } from 'react';
import { InterfaceContext } from '../model/InterfaceProvider';
import { reloadcountiesxml, loadcountiesxml, opencountymap } from '../controller/PreparedCountyMapController';

const PreparedMaps = () => {
    const { year, preparedMapState, preparedMapCounty } = useContext(InterfaceContext);
    const [usstate, setUSstate] = useState(preparedMapState);
    const [county, setCounty] = useState(preparedMapCounty);
    const [localYear, setLocalYear] = useState(year);

    const onStateChange = (e) => {
        loadcountiesxml();
        setUSstate(e.target.value);
    };
    const onSetCounty = (e) => {
        setCounty(e.target.value);
    };
    const onChangeYear = (e) => {
        setLocalYear(e.target.value);
        reloadcountiesxml();
    };

    useEffect(() => {
        window.addEventListener('CountyPopulation', updateCountyValue);
        return () => {
            window.removeEventListener('CountyPopulation', updateCountyValue);
        };
    }, []);
    const updateCountyValue = () => {
        if (preparedMapCounty) {
            setCounty(preparedMapCounty);
            document.querySelector('#County').value = preparedMapCounty;
        }
    };

    useEffect(() => {
        loadcountiesxml();
        setUSstate(preparedMapState);
        setCounty(preparedMapCounty);
    }, [preparedMapState]);

    return (
        <>
            <div className="listContainer">
                <p>Select from the dropdown menus below to view the county map series.</p>
                <div className="infofield">
                    <label htmlFor="Year">Year</label>
                    <select id="Year" name="Year" value={localYear} onChange={onChangeYear}>
                        <option value="2022">2022</option>
                        <option value="2020">2020</option>
                        <option value="2018">2018</option>
                        <option value="2016">2016</option>
                        <option value="2014">2014</option>
                        <option value="2010">2010</option>
                        <option value="2000">2000</option>
                    </select>
                </div>
                <div className="infofield">
                    <label htmlFor="State">State</label>
                    <select id="State" value={usstate} onChange={onStateChange}>
                        <option value="" selected="">
                            &nbsp;---------- Select a state ----------&nbsp;&nbsp;
                        </option>
                        <option value="Alabama">Alabama</option>
                        <option value="Alaska">Alaska</option>
                        <option value="Arizona">Arizona</option>
                        <option value="Arkansas">Arkansas</option>
                        <option value="California">California</option>
                        <option value="Colorado">Colorado</option>
                        <option value="Connecticut">Connecticut</option>
                        <option value="Delaware">Delaware</option>
                        <option value="District of Columbia">District of Columbia</option>
                        <option value="Florida">Florida</option>
                        <option value="Georgia">Georgia</option>
                        <option value="Hawaii">Hawaii</option>
                        <option value="Idaho">Idaho</option>
                        <option value="Illinois">Illinois</option>
                        <option value="Indiana">Indiana</option>
                        <option value="Iowa">Iowa</option>
                        <option value="Kansas">Kansas</option>
                        <option value="Kentucky">Kentucky</option>
                        <option value="Louisiana">Louisiana</option>
                        <option value="Maine">Maine</option>
                        <option value="Maryland">Maryland</option>
                        <option value="Massachusetts">Massachusetts</option>
                        <option value="Michigan">Michigan</option>
                        <option value="Minnesota">Minnesota</option>
                        <option value="Mississippi">Mississippi</option>
                        <option value="Missouri">Missouri</option>
                        <option value="Montana">Montana</option>
                        <option value="Nebraska">Nebraska</option>
                        <option value="Nevada">Nevada</option>
                        <option value="New Hampshire">New Hampshire</option>
                        <option value="New Jersey">New Jersey</option>
                        <option value="New Mexico">New Mexico</option>
                        <option value="New York">New York</option>
                        <option value="North Carolina">North Carolina</option>
                        <option value="North Dakota">North Dakota</option>
                        <option value="Ohio">Ohio</option>
                        <option value="Oklahoma">Oklahoma</option>
                        <option value="Oregon">Oregon</option>
                        <option value="Pennsylvania">Pennsylvania</option>
                        <option value="Puerto Rico">Puerto Rico</option>
                        <option value="Rhode Island">Rhode Island</option>
                        <option value="South Carolina">South Carolina</option>
                        <option value="South Dakota">South Dakota</option>
                        <option value="Tennessee">Tennessee</option>
                        <option value="Texas">Texas</option>
                        <option value="Utah">Utah</option>
                        <option value="Vermont">Vermont</option>
                        <option value="Virginia">Virginia</option>
                        <option value="Washington">Washington</option>
                        <option value="West Virginia">West Virginia</option>
                        <option value="Wisconsin">Wisconsin</option>
                        <option value="Wyoming">Wyoming</option>
                    </select>
                </div>
                <div className="infofield">
                    <label htmlFor="County">County</label>
                    <select id="County" value={county} onChange={onSetCounty}>
                        <option value="" selected="">
                            &nbsp;------- Select a state first -------
                        </option>
                    </select>
                </div>
                <div className="infofield">
                    <input type="button" name="viewCountuyMap" value="View County Map" onClick={opencountymap}></input>
                </div>
            </div>
        </>
    );
};

export default PreparedMaps;
